export default __webpack_public_path__ + "static/media/setscoldhatred.83b477c5.png";